module.exports = __webpack_public_path__ + "static/media/logo-company.3c368ba2.svg";